import React from 'react';
import { Dropdown } from 'semantic-ui-react';

import { PagoCobroCalculado } from '../tipos';
import EliminarPagoCobroCalculado from './EliminarPagoCobroCalculado';

type EstadoCobroCalculado = 'POR_PAGAR' | 'PAGADA' | 'ABONADA';

interface Props {
    idPlanDePago: string;
    pagos: Array<PagoCobroCalculado> | undefined;
    estadoCobroCalculado: EstadoCobroCalculado;
    alEditarPago(): void;
}

const AccionesTablaCobrosCalculados: React.FunctionComponent<Props> = props => {
    const { estadoCobroCalculado, pagos, idPlanDePago, alEditarPago } = props;

    return (
        <Dropdown
            icon='ellipsis vertical'
            pointing='top right'
            disabled={estadoCobroCalculado === 'POR_PAGAR'}
        >
            <Dropdown.Menu>
                <EliminarPagoCobroCalculado
                    pagos={pagos!}
                    idPlanDePago={idPlanDePago}
                    alEditarPago={alEditarPago}
                />
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default AccionesTablaCobrosCalculados;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Componentes/AccionesTablaCobrosCalculados.tsx